import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  };
  return <section className="w-full py-20 lg:py-28" data-id="element-512">
      <div className="container mx-auto" data-id="element-513">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto text-center" data-id="element-514">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-515">
            Join the lab
          </p>
          <h2 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground" data-id="element-516">
            Early access, batch updates, and{' '}
            <span className="font-mono text-primary" data-id="element-517">10%</span> off your first
            order.
          </h2>
          <p className="mt-5 text-[15px] text-muted-foreground leading-relaxed max-w-xl mx-auto" data-id="element-518">
            One email a month. New batches, new peptides, occasional research
            notes. Unsubscribe anytime.
          </p>

          {submitted ? <div className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary/10 text-primary text-sm font-medium" data-id="element-519">
              <CheckCircle2 className="h-4 w-4" data-id="element-520" />
              You're on the list. Check your inbox.
            </div> : <form onSubmit={onSubmit} className="mt-8 flex flex-col sm:flex-row items-stretch gap-3 max-w-md mx-auto" data-id="element-521">
              <Input type="email" required placeholder="you@email.com" value={email} onChange={e => setEmail(e.target.value)} className="rounded-full h-12 px-5 bg-card" aria-label="Email address" data-id="element-522" />
              <Button type="submit" size="lg" className="rounded-full px-6" data-id="element-523">
                Subscribe{' '}
                <ArrowRight className="h-4 w-4 ml-1" strokeWidth={2} data-id="element-524" />
              </Button>
            </form>}

          <p className="mt-5 text-[11px] text-muted-foreground" data-id="element-525">
            By subscribing you agree to our privacy policy. No spam — ever.
          </p>
        </motion.div>
      </div>
    </section>;
}